import { NgModule                } from '@angular/core';
import { RouterModule, Routes    } from '@angular/router';
import { OficinasListarComponent } from './oficinas-listar/oficinas-listar.component';
import { OficinasEditarComponent } from './oficinas-editar/oficinas-editar.component';

const routes: Routes = [
    {
        path: '',
        component: OficinasListarComponent
    },
    {
        path: 'agregar',
        component: OficinasEditarComponent,
    },
    {
        path: ':id',
        component: OficinasEditarComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class OficinasRoutingModule { }